import styled from "@emotion/styled";

export const FeedbackContent = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 1rem;
`;
